import React, { UIEvent } from "react";
import { useMemoizedFn } from "ahooks";
import { IonSpinner } from "@ionic/react";
import { OrderChatMessage } from "@core/types";
import MessageBubble from "./MessageBubble";

type MessagesListProps = {
  messages: OrderChatMessage[];
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  operatorLastReadAt: string | null;
  onLoadMore: () => void;
};

const LOAD_MORE_THRESHOLD = 0.1;

const isNearTopInReverse = (el: HTMLDivElement) => {
  const distanceFromTop = el.scrollHeight + el.scrollTop - el.clientHeight;
  return distanceFromTop <= el.clientHeight * LOAD_MORE_THRESHOLD;
};

const MessagesList = ({
  messages,
  isFetchingNextPage,
  hasNextPage,
  operatorLastReadAt,
  onLoadMore,
}: MessagesListProps) => {
  const handleScroll = useMemoizedFn((e: UIEvent<HTMLDivElement>) => {
    if (!hasNextPage || isFetchingNextPage) return;
    if (isNearTopInReverse(e.currentTarget)) onLoadMore();
  });

  return (
    <div className="flex-1 overflow-y-auto px-2.5 py-3 flex flex-col-reverse gap-2" onScroll={handleScroll}>
      {messages.map((message) => (
        <MessageBubble
          key={message.clientId ?? message.id}
          message={message}
          operatorLastReadAt={operatorLastReadAt}
        />
      ))}
      {isFetchingNextPage && (
        <div className="flex justify-center py-2">
          <IonSpinner name="dots" />
        </div>
      )}
    </div>
  );
};

export default MessagesList;
